/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  $( document ).ready(function() {   
    if( typeof product_variants_removed != undefined ) {  // was there items to be removed?
      product_variants_removed.forEach(function(item){
        let prdValue = item.split("/")[0].trim();
        $('.select-popout__list .select-popout__item').each(function(){
          let valueTmp = $(this).find('[data-popout-option]').attr("data-value");
          let valueA = $(this).find('[data-popout-option]');

          if(prdValue == valueTmp){
            console.log(valueTmp,prdValue);
            valueA.addClass("prd__unavailabe");
            return;
          }
        })
      });    
    }
  });

  
$( document ).ready(function() {   
  $('.custom-colour-popout__toggle').click(function(){
    $(this).toggleClass("custom-colour-popout-border");
    $('.custom-select-popout__list').toggleClass("custom-colour-popout-show");
  }); 

  // code to add red color to menu
    // desktop
    document.querySelectorAll(".menu__item").forEach((menu)=>{
        if(menu.innerText.indexOf("Sale")>=0){
            menu.querySelector("a").style.color = "red";
        }
    })

    // mobile
    document.querySelectorAll(".sub-menu-items").forEach((menu)=>{
        if(menu.innerText.indexOf("VALENTINE'S SALE")>=0){
            menu.querySelector("a").style.color = "red";
        }
    })

    document.querySelectorAll(".sliderule__wrapper").forEach((menu)=>{
        if(menu.textContent.indexOf("Sale")>=0){
            menu.querySelector(".sliderow").style.color = "red";
        }
    })
    // end of code to add red color to menu
  
}); 

  $( document ).ready(function() {    
    for (let i = 0; i < uniqueProductColor.length; i++) { 
      $('#color').append('<option id="colorOption" dataColor="'+ uniqueProductColor[i] +'" value="'+ uniqueProductColor[i] +'">'+ uniqueProductColor[i] +'</option>');
    }
    
    for (let i = 0; i < uniqueProductSize.length; i++) { 
      $('#size').append('<option id="sizeOption" dataSize="'+ uniqueProductSize[i] +'" value="'+ uniqueProductSize[i] +'">'+ uniqueProductSize[i] +'</option>');
    }
   
    setTimeout(function() {
      $('#color').on('change', function() {
        let color_change_val = $(this).val();
        console.log(color_change_val);
        if(color_change_val != ""){
		$('#size #sizeOption').prop('disabled', true);
        for (let i = 0; i < productOption.length; i++) { 
          if(color_change_val == productOption[i][0]){
            $('#size #sizeOption[dataSize="'+ productOption[i][1] +'"]').prop('disabled', false);
          }
        }
        }else{$('#size #sizeOption').prop('disabled', false);}
      }) 
    },3000);
    
        setTimeout(function() {
      $('#size').on('change', function() {
        let size_change_val = $(this).val();
        console.log(size_change_val);
        if(size_change_val != ""){
		$('#color #colorOption').prop('disabled', true);
        for (let i = 0; i < productOption.length; i++) { 
          if(size_change_val == productOption[i][1]){
            $('#color #colorOption[dataColor="'+ productOption[i][0] +'"]').prop('disabled', false);
          }
        }
        }else{$('#color #colorOption').prop('disabled', false);}
      }) 
    },3000);
    
    $('#size').focus(function(){
      $(this).attr('size','6');
      $(this).css('border','1px solid #eee');
    });
    $('#color').focus(function(){
      $(this).attr('size','6');
      $(this).css('border','1px solid #eee');
    });
    
    $('#size').blur(function(){
      $(this).attr('size','1')
    });
    $('#color').blur(function(){
      $(this).attr('size','1')
    });
    
    $('#size').change(function(){
      $(this).attr('size','1');
      $(this).blur();
    });
    $('#color').change(function(){
      $(this).attr('size','1');
      $(this).blur();
    });

  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
  
    
  $( document ).ready(function() {   
  $('.dvSizeCaculate input').on("keyup change", function(){
    
    var upsize = $("#txtUpSize").val();
    var downsize = $("#txtDownSize").val();
    
    var diff = parseFloat(upsize) - parseFloat(downsize);
 if($(this).val() == '' || $(this).val() == null ){
   
   $(this).parent().find("p.placeholder_text").show();
   }else{
   	$(this).parent().find("p.placeholder_text").hide();
  
   }
   
    
       if ( upsize == '' ||  downsize == '') {
     
         		$("#dvSizeOutput").html("What's my bra size");
                
            }
    
    else{
    
     if (parseFloat(upsize) < parseFloat(downsize) ||
               parseFloat(diff) > 33.9 ||
                parseFloat(downsize) > 102.9) {
       
       
       $("#dvSizeOutput").html("What's my bra size");
               
     }else{
       
       var _DownSize = parseFloat(downsize);
            var bra_size = '';

            if (_DownSize <= 67.9) {
                bra_size = '65'
            } else if (_DownSize <= 72.9) {
                bra_size = '70'
            } else if (_DownSize <= 77.9) {
                bra_size = '75'
            } else if (_DownSize <= 82.9) {
                bra_size = '80'
            } else if (_DownSize <= 87.9) {
                bra_size = '85'
            } else if (_DownSize <= 92.9) {
                bra_size = '90'
            } else if (_DownSize <= 97.9) {
                bra_size = '95'
            } else if (_DownSize <= 102.9) {
                bra_size = '100'
            } else {
                bra_size = ''
            }

       
       var _SizeDiff = parseFloat(upsize) - parseFloat(downsize);
            var cupsize = '';

            if (_SizeDiff <= 10.4) {
                cupsize = 'A'
            } else if (_SizeDiff <= 13.9) {
                cupsize = 'B'
            } else if (_SizeDiff <= 16.4) {
                cupsize = 'C'
            } else if (_SizeDiff <= 18.9) {
                cupsize = 'D'
            } else if (_SizeDiff <= 21.4) {
                cupsize = 'E'
            } else if (_SizeDiff <= 23.9) {
                cupsize = 'F'
            } else if (_SizeDiff <= 26.4) {
                cupsize = 'G'
            } else if (_SizeDiff <= 28.9) {
                cupsize = 'H'
            } else if (_SizeDiff <= 31.4) {
                cupsize = 'I'
            } else if (_SizeDiff <= 33.9) {
                cupsize = 'J'
            } else {
                cupsize = ''
            }
       
       if(bra_size != "" && cupsize != ""){
          var output = bra_size + cupsize;
         
         $("#dvSizeOutput").html("<span>"+output+"</span>");
         
         
       }
       
     
     }
      
    }
   
  }); 
  
});
  setTimeout(function(){console.log('trigger');$(".section-faq.accordion.product-details h2").trigger('click');}, 3000);

  $(document).ready(function() {
    $("#product-arrow-up").hide();
    $("#product-thumbs-square>.thumbs-holder").scroll(function() {
         let ele = $("#product-thumbs-square>.thumbs-holder");
         if(ele.scrollTop() + ele.height() == ele[0].scrollHeight) {
             $("#product-arrow-down").hide();
         }
         else{
           $("#product-arrow-down").show();
         }

         if($("#product-thumbs-square>.thumbs-holder").scrollTop() == 0){
           $("#product-arrow-up").hide();
         }
         else{
           $("#product-arrow-up").show();
         }
    }); 

    // back in stock code

    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    $("#bis-submit-btn").click(()=>{
      let bis_email = $("#bis_email").val();
      let validEmail = validateEmail(bis_email);
      if(validEmail){
        let product_id = meta.product.id;
        let variant_id = $(".product-form input[name='id']").val();
        sendBackInStockCall(bis_email, variant_id, product_id);
      }
      else{
        $("#bis-email-error").show();
      }
    });

    $("#bis_email").keyup(function(){
      $("#bis-email-error").hide();
    });

    function checkAndShowBIS(){
        let bisStatus = $(".product__submit__add").text();

        if(bisStatus.indexOf("Add to cart")>=0){
          console.log(1);
          $("#bis-oos-form-app").hide();
        }
        else{
          console.log(2);
          $("#bis-oos-form-app").show();
        }

        $("#bis-email-div").show();
        $("#bis-success-div").hide();
    }

    checkAndShowBIS();

    $('.product__submit__item').on("DOMSubtreeModified", checkAndShowBIS);

    function sendBackInStockCall(email, variant_id, product_id) {
      fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
        "headers": {
          "accept": "application/json, text/plain, */*",
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        "body": new URLSearchParams({
            "a": "UpRL4v",
            "email": email,
            "platform": "shopify",
            "variant": variant_id, 
            "product": product_id,
        }),
        "method": "POST",
      })
      .then(response => {
          console.log(response);

          $("#bis-email-div").hide();
          $("#bis-success-div").show();
      })
      .catch(err => {
          console.error(err);
      });
    }
    
  });
  
  (function(){
    var coll = document.getElementsByClassName("collapsible");
    var i;
  
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = "fit-content";
        } 
      });
    }
  })();
})();

